"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionCondition = void 0;
const join_condition_1 = require("./join-condition");
const condition_1 = require("./condition");
const list_field_1 = require("./list-field");
const _ = __importStar(require("lodash"));
class SectionCondition extends condition_1.Condition {
    constructor() {
        super("Section Condition");
        this.condition = new join_condition_1.JoinCondition();
    }
    static transformToListField(node) {
        let listField = new list_field_1.ListField();
        listField.accessor = node.accessor;
        listField.display = node.display;
        listField.type = node.type;
        if (_.isEmpty(node.children)) {
            return listField;
        }
        const children = _.map(node.children, (child) => SectionCondition.transformToListField(child));
        listField.fields = children;
        listField.listFields = children;
        return listField;
    }
    static createRuleAssistCondition(node, objectChildren) {
        let section = new SectionCondition();
        section.listAccessor = node.accessor;
        section.listAccessorDisplay = node.display;
        section.selected = SectionCondition.transformToListField(node);
        section.condition.set(objectChildren);
        return section;
    }
}
exports.SectionCondition = SectionCondition;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/casa-rules-v2/section-condition.js
// module id = 1246
// module chunks = 0